export function buildSlug(mediaItem) {
  const title = mediaItem.name || '';
  const id = mediaItem._id;

  const baseSlug = title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '+')
    .replace(/\++/g, '+')
    .replace(/^\+|\+$/g, '')
    || 'unknown-video';

  const uniquePart = id ? id.slice(-6) : '';
  return `${baseSlug}+${uniquePart}`;
}

export function normalizeDomain(raw) {
  return (raw || '')
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '');
}

export function buildVideoUrl(mediaItem, distribution) {
  const rawDomain = distribution && distribution.playerSettings && distribution.playerSettings.domain;
  const slug = buildSlug(mediaItem);
  let url;

  if (rawDomain && rawDomain.trim().length > 0) {
    const domain = normalizeDomain(rawDomain);
    url = new URL(`https://${domain}`);
    url.searchParams.set('videoSlug', slug);
    return url.toString();
  }

  url = new URL(`${distribution._id}`, `${process.env.VIDEO_DECK_PLAYER_URL}/`);
  url.searchParams.set('videoSlug', slug);
  return url.toString();
}



// WEBPACK FOOTER //
// ./src/common/utils/videoUtils.js